import './styles.scss';

import React, { useContext } from 'react';

import { CoreContext } from '../../providers';
import { VisibleOn } from '../../components/VisibleOn';
import { Container } from '../../components/Container';
import { KaiScore } from '../../components/KaiScore';
import { FunFacts } from '../../components/FunFacts';

interface DebtTellerProps {
    scoreTellerTitle: string;
    funFactsTitle: string;
    backgroundImage: string;
}

/**
 * The DebtTeller is a "fancy step" that displays an animation from 0 to 1000
 * fortth and back
 */
export const DebtTeller: React.FC<DebtTellerProps> = ({
    scoreTellerTitle,
    funFactsTitle,
    backgroundImage,
}) => {
    const { settings } = useContext(CoreContext);
    return (
        <div className="ScoreTellerScene">
            {backgroundImage && (
                <VisibleOn tablet desktop>
                    <picture className="ScoreTellerScene__background">
                        <img src={backgroundImage} alt="Background" />
                    </picture>
                </VisibleOn>
            )}
            <Container className="ScoreTellerScene__wrapper" sizeGroup="size-1">
                {scoreTellerTitle && (
                    <VisibleOn mobile>
                        <h2
                            className="ScoreTellerScene__title"
                            dangerouslySetInnerHTML={{
                                __html: scoreTellerTitle,
                            }}
                        />
                    </VisibleOn>
                )}
                <KaiScore
                    countUpInitialValue={1}
                    countUpMaximumValue={1000}
                    countDuration={5}
                    countUpLoopMode={true}
                    variant={
                        settings.languageVersion === 'upscore'
                            ? 'bubble'
                            : 'speedometer'
                    }
                />
                {funFactsTitle && <FunFacts title={funFactsTitle} />}
            </Container>
        </div>
    );
};
